<template>
    <div id="login" v-show="showLogin">
        <div class="mask"></div>
        <div class="container">
            <div class="no_login" @click="closed">不领了，谢谢</div>
            <div class="go_login" @click="goLogin">立即领取</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'GetCode',
        props: {
            showLogin: ''
        },
        methods: {
            goLogin: function () {
                window.location.href = 'http://c.youdao.com/dict/commons/login.html?back_url=' + encodeURIComponent(window.location.href)
            },
            closed: function () {
                this.$emit('isLogin')
            }
        }
    }
</script>

<style>
    #login {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }
    .mask {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: #000;
        opacity: 0.5;
        filter: alpha(opacity=50);
    }
    #login .container {
        position: fixed;
        top: 4.5rem;
        left: 50%;
        bottom: 0;
        right: 0;
        z-index: 99;
        margin-left: -2.785rem;
        background-image: url(http://shared.youdao.com/dict/market/oxford-activity/imgs/login.png);
        background-size: 100% 100%;
        width: 5.57rem;
        height: 2.72rem;
        overflow: hidden;
    }
    .no_login, .go_login {
        width: 1.82rem;
        height: 0.4rem;
        text-align: center;
        line-height: 0.4rem;
        border-radius: 0.3rem;
        color: #ffffff;
        font-size: 0.18rem;
        background-color: #c6934c;
        margin-top: 1.6rem;
    }
    .no_login {
        float: left;
        margin-left: 0.54rem;
    }
    .go_login {
        float: right;
        margin-right: 0.54rem;
    }
</style>



// WEBPACK FOOTER //
// Login.vue?67bd817d